/**
 * AuthCard — shared layout for the auth pages (Login, Register, …).
 *
 * Centered card on a neutral canvas with the Tile logo on top, then the
 * page-specific title / subtitle / form. Matches DESIGN.md:
 *   - white card, 400px max width, soft elevation
 *   - shadow-as-border on inputs and buttons
 *   - Tile Blue as the only accent
 *   - Inter font (already loaded by public/index.html)
 */
import React, { ReactNode } from 'react';

import Logo from '@/shared/components/logo/Logo';

import '@/features/auth/components/auth.styles.css';

type Props = {
  title: string;
  subtitle?: string;
  /** Optional — a status-only card (e.g. /cli-login) has no body. */
  children?: ReactNode;
};

export default function AuthCard({ title, subtitle, children }: Props) {
  return (
    <div className="tile-auth-host">
      <div className="auth-card">
        <div className="auth-logo" aria-hidden>
          <Logo width={96} />
        </div>
        <h1 className="auth-title">{title}</h1>
        {subtitle ? <p className="auth-subtitle">{subtitle}</p> : null}
        {children}
      </div>
    </div>
  );
}
